import React, { Component } from 'react';
import FormatValue from '../../helpers/FormatValue';

interface IFormatValueProps {
   value: number;
   type: string;
   scale: string;
   precision: string;
}

export default class FormattedValue extends Component<IFormatValueProps, {}> {
   public render() {
      const { value, type, scale, precision } = this.props;
      return <div> {FormatValue(value, type, scale, precision)} </div>;
   }
}
